import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import useIsMounted from '../../hooks/useIsMounted';
import TextInput from '@components/forms/TextInput'
import { useAuth } from '@contexts/authContext';
import Button from '@components/ui/Button';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router';
import AlertBox from '@components/ui/AlertBox';
import { toast } from 'sonner';
import PasswordInput from '../../components/forms/PasswordInput';

function LoginPage() {

  let navigate = useNavigate();
  let [searchParams, _] = useSearchParams();
  let { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  let { user, login } = useAuth();
  const [pageError, setPageError] = useState('')
  const isMounted = useIsMounted();

  // redirect the user to he's profile if already looged int
  useEffect(() => {
    if (!isMounted.current) {
      if (user) {
        console.log('it is logging');
        
        toast.info("You're already logged in");
        navigate('/profile');
      }
    }
  }, [user, navigate]);
  

  let onSubmit = async (data) => {
    // clear error
    setPageError('')
    try {
      const user = await login(data)
      toast.success('Login successful')
      if(!user.is_profile_complete){
        return navigate('/complete-profile',)
      } else if (searchParams.get('redirect')) {
        return navigate(searchParams.get('redirect'), { replace: true });
      } else if (user.is_admin){
        return navigate('/admin', { replace: true });
      } else if (user.user_type == 'lecturer') {
        return navigate('/lecturer/quizzes', { replace: true });
      } else if (user) {
        return navigate('/discover', { replace: true });
      } else {
        setPageError('Login succeeded but user data is missing.');
      }
    } catch (error) {
      console.log('from component', error);
      setPageError(error)
    }
  }

  return (
    <div className='flex justify-center items-center min-h-[calc(100vh-100px)]'>
      <div className='w-full max-w-md px-4'>
        <div className="text-center mb-8 mt-2">
          <h1 className="text-3xl font-bold">Welcome Back!</h1>
          <p className="mt-3 text-base-content/70">Please sign in to your account</p>
        </div>

        <div className='card bg-base-100 shadow-xl'>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="card-body"
          >
            <AlertBox message={pageError} type='error' />
            
            <TextInput
              label="Email"
              name="email"
              type='email'
               placeholder="john.doe@example.com"
              register={register}
              errors={errors}
              validationRules={{ required: 'Email is required' }}
            />

            <div>
            <PasswordInput
              label="Password"
              name="password"
              register={register}
              errors={errors}
              placeholder="********"
              validationRules={{ required: 'Password is required' }}
            />
            <Link className='text-xs float-end hover:underline' to={'/request-reset-password'}>Forgot Password?</Link>
            </div>

            <Button
              isLoading={isSubmitting}
              className='w-full mt-4'
            >
              Login
            </Button>
           {/* Sign Up Link */}
           <div className="text-center text-sm">
              Don't have an account?{" "}
              <Link to="/signup" className="link link-primary">
                Sign up
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginPage